import styled from 'styled-components';

export const MenuLeftWrapper = styled.div`
  display: flex;
  .menu-left {
    &__item {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 40px;
      height: 40px;
      margin-right: 5px;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      &--info {
        border-radius: 0.475rem;
        overflow: hidden;
      }
      &:hover {
        border-radius: 0.475rem;
        background-color: rgba(245, 248, 250, 0.8);
      }
      .anticon {
        font-size: 20px;
      }
    }
  }
`;

export const MenuDropdownWrapper = styled.div``;
